import {
    getSelectedTableView,
    listViewStore,
    TableQueryType,
    TableView,
} from 'owa-mail-list-store';

export function getSelectedGroupId(): string {
    const tableView = getSelectedTableView();
    return getGroupId(tableView);
}

export function getGroupId(tableView: TableView): string {
    return tableView && tableView.tableQuery.type == TableQueryType.Group
        ? tableView.tableQuery.folderId
        : null;
}

export function getGroupIdFromTableViewId(tableViewId: string): string {
    const tableView = listViewStore.tableViews.get(tableViewId);
    return getGroupId(tableView);
}
